import React from "react";

const Settings = () => {
  return (
    <div className="container py-5">
      <h2 className="mb-4">Settings</h2>
      <div className="card p-4">
        <p>Settings page content goes here.</p>
        {/* Add your settings form or options here */}
      </div>
    </div>
  );
};

export default Settings;
